import { getAccountIdFromPathname } from "./account-context";

/**
 * Self-serve subscription funnel screens that omit app chrome
 * (top header, left sidebar, footer). Checkout and payment result
 * pages keep full app chrome so users can navigate the product.
 */
const SAAS_SUBSCRIPTION_PATH_SUFFIXES = Object.freeze([
  "/plans",
  "/choose-path",
  "/paywalls/free-avatar",
  "/paywalls/zero-credits",
]);

export function getUnscopedPathname(pathname = "/") {
  const normalized = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const accountId = getAccountIdFromPathname(normalized);
  if (!accountId) {
    return normalized;
  }
  const stripped = normalized.replace(new RegExp(`^/${accountId}(?=/|$)`), "");
  return stripped || "/";
}

export function isSaasSubscriptionChromePath(pathname = "/") {
  const rest = getUnscopedPathname(pathname);
  return SAAS_SUBSCRIPTION_PATH_SUFFIXES.some(
    (suffix) => rest === suffix || rest.startsWith(`${suffix}/`)
  );
}
